import styled from '@emotion/styled'
import { CircularProgress } from '@material-ui/core'

export const Spinner = styled(CircularProgress)`
  margin: 20px -30px;
`
